import { getRuleFiltersConfigBySection } from '@kw/quokka-ui';
import { FiltersAndTable } from '../FiltersAndTable';

interface IProps {
  ruleSummaries: object;
  analysisId: string;
  section?: 'overview' | 'permission' | 'behaviors' | 'malicious' | '';
  customRules?: object;
  refresh?: () => void; // when we want to refresh the custom rules data after a review action
}

export const RulesTab = ({ ruleSummaries, analysisId, section = 'overview', customRules, refresh }: IProps) => {
  const filtersConfig = getRuleFiltersConfigBySection({ ruleSummaries, section });
  return <FiltersAndTable filtersConfig={filtersConfig} analysisId={analysisId} data={ruleSummaries} customRules={customRules} refresh={refresh}/>;
};
